import React, { Component } from 'react'
import Button from '@material-ui/Core/Button'
import { Page, Text, View, Document, Link, StyleSheet, ReactPDF, PDFViewer} from '@react-pdf/renderer'

const styles = StyleSheet.create({
    page: { backgroundColor: 'tomato' },
    section: { textAlign: 'center', margin: 30 }
  });

const testProps = {
    "ComponentContent": {
        "Buttons": [ {
                "Text": "Ask a nurse",
                "Visible": "1",
                "Link": "www.web1.com",
                "Color": "primary"
            },{
                "Text": "Make an appointment",
                "Visible": "1",
                "Link": "www.web32.com",
                "Color": "primary"
            },{
                "Text": "More info",
                "Visible": "1",
                "Link": "www.web45.com",
                "Color": "primary"
            }
        ]
    }
}

const MyDocument = function(){
    let Views = []
    for(let x=0; x<testProps.ComponentContent.Buttons.length; x++){
        Views.push(<Text ><Link src={testProps.ComponentContent.Buttons[x].Link}>{testProps.ComponentContent.Buttons[x].Text}</Link></Text>)
    }
    return (
        <Document>
            <Page size="A4" style={styles.page}>
              <View style={styles.section}>
                <Text>no</Text>
              </View>
              <View style={styles.section}>
                <Text>Section #2</Text>
              </View>
            </Page>
        </Document>
    )
}


function PDF(props){

    return(
        <MyDocument />
    )
    
}

export default PDF; 